import {
    STUDIO_TOGGLE_IMAGE_SETTINGS_MODAL,
    UNAUTHENTICATED
} from "../../actions/action-types"

const defaultState = false

export default (state = defaultState, action) => {
    const { type } = action
    switch (type) {
        case STUDIO_TOGGLE_IMAGE_SETTINGS_MODAL:
            return !state
        case UNAUTHENTICATED:
            return defaultState
        default:
            return state
    }
}
